module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAALVBMVEUAAAAzMzMzMzMyMjIzMzMzMzMzMzMzMzM0NDQwMDAzMzM5OTk0NDQzMzMzMzOdlNq4AAAAD3RSTlMAv/+A4Ddoi5kgVQmteJ/mvjV0AAAAU0lEQVR4nGNAAZyPlJR0NoCZLI6CgiIKYOaiAAYGVl0w0whEKJLKLFICA3UgU9AYDARBTIidUCZbApzJBLQWymQWQDAN4Ey4NigAMpsgVmgg+wYAmNYLuwk6Q3MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/lock.png
// module id = SlL1
// module chunks = 0